import lightFormat from 'date-fns/lightFormat';
import { plural } from '@cian/utils';
import { IPublishOption } from '../../../redux/reducers';

const OFFER_VARIANTS: [string, string, string] = ['объявление', 'объявления', 'объявлений'];
const DATE_PATTERN = 'dd.MM.yy, HH:mm';

export function formatPackageName(servicePackage: IPublishOption, isMobile: boolean): string {
  const { servicePackageEndDate, servicePackageActualCount } = servicePackage;

  const formattedCount = `${servicePackageActualCount} ${plural(servicePackageActualCount, OFFER_VARIANTS)}`;
  const formattedEndDate = lightFormat(new Date(servicePackageEndDate), DATE_PATTERN);

  if (isMobile) {
    return `${formattedCount} до ${formattedEndDate}`;
  }

  return `Доступно ${formattedCount} до ${formattedEndDate}`;
}
